/** Ruta de arranque de la PWA instalada (manifest `start_url` en plataforma). */
export const PWA_LAUNCH_PATH = "/launch";

export function isPwaStandalone(): boolean {
  if (typeof window === "undefined") return false;
  const nav = navigator as Navigator & { standalone?: boolean };
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    nav.standalone === true
  );
}

/** Destino tras login o al abrir la PWA con sesión activa. */
export function resolveAuthenticatedAppPath(role: string): string {
  if (role === "super_admin" || role === "support" || role === "viewer") return "/admin";
  return "/app/dashboard";
}

/** Rutas del workspace autenticado (no redirigir a /launch desde PWA). */
export function isPwaAppPath(pathname: string): boolean {
  return (
    pathname === PWA_LAUNCH_PATH ||
    pathname.startsWith("/app") ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/acceso/comercio") ||
    pathname.startsWith("/admin")
  );
}

/**
 * Sitio público: en PWA standalone debe poder navegarse sin forzar login.
 * Incluye landing, storefront /market/*, contratar, docs, etc.
 */
export function isPwaPublicPath(pathname: string): boolean {
  if (pathname === "/") return true;

  const exact = new Set([
    "/contratar",
    "/prueba-gratis",
    "/solicitar-trial",
    "/docs",
    "/login",
    "/acceso/comercio",
    "/register",
    "/marketing",
    "/launch",
    "/forgot-password",
    "/baja-servicio",
    "/arrepentimiento",
  ]);
  if (exact.has(pathname)) return true;

  const prefixes = [
    "/market/",
    "/market_/",
    "/widget/",
    "/pay/",
    "/auth/",
    "/docs/",
    "/reset-password",
    "/institucional/",
    "/invitation/",
    "/print/",
  ];
  return prefixes.some((p) => pathname.startsWith(p));
}
